import { render, staticRenderFns } from "./ContentDiscoverableForm.vue?vue&type=template&id=2fd2c174&scoped=true&"
import script from "./ContentDiscoverableForm.vue?vue&type=script&lang=js&"
export * from "./ContentDiscoverableForm.vue?vue&type=script&lang=js&"
import style0 from "./ContentDiscoverableForm.vue?vue&type=style&index=0&id=2fd2c174&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../.yarn/$$virtual/vue-loader-virtual-a9dd69dad6/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd2c174",
  null
  
)

export default component.exports